import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Button, Card, Col, Row, Container } from "react-bootstrap";
import { FloatingControlComponent } from "../../../../components/FormComponent";
import {
  formatDate,
  formatSplitKey,
} from "../../../../commons/FormatValue";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import PrintButton from "../../../../components/PrintButton";
import ReportHeadComponent from "../../../../components/ReportHeadComponent";
import { Helmet } from "react-helmet-async";
import PaginationComponent from "../../../../components/PaginationComponent";
import TechItemReturnService from "../../../../services/techitemreturn";
import { useAuth } from "../../../../context/AuthContext";
import Table from "../../../../components/Table";
import { useLoading } from "../../../../context/LoadingContext";
import { formatDateTime } from "../../../../commons/FormatValue";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import FileUploadsService from "../../../../services/fileupload.service";
import ServiceRequestService from "../../../../services/servicerequest.service";
import { getQueryString } from "../../../../utils/Query";

const PreviewReportPage = () => {
  const navigate = useNavigate();
  const canvasRef = useRef(null);
  const { user } = useAuth();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [currentPage, setCurrentPage] = useState(1);
  const [defaultData, setDefaultData] = useState()

  const inputField = {
    headerReport: [
      {
        name: "Service_rep_no",
        label: "เลขที่ใบรายงานบริการ",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 12
      },
      {
        name: "Job_Cus_Date",
        label: "วันที่ปฏิบัติงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "Time",
        label: "เวลา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
    ],
    Inform: [
      {
        name: "BP_Code",
        label: "รหัสลูกค้า (BP Code)",
        size: 4,
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Num_branch",
        label: "รหัสสาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 2
      },
      {
        name: "Cus_Name",
        label: "ชื่อลูกค้่า/สาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "Seq_No",
        label: "เลขที่ใบสั่งงาน",
        size: 4,
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "PM",
        label: "PM ครั้งที่",
        size: 1,
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Sq",
        label: "Sq.",
        size: 1,
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Name",
        label: "ชื่อสินค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 3
      },
      {
        name: "Serial_No",
        label: "หมายเลขเครื่อง(Serial No.)",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 3
      },
      {
        name: "Location",
        label: "จุดที่ตั้งเครื่องจักร",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "Work_No",
        label: "เลขที่ปฏิบัติงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 3,
      },
      {
        name: "Ticket",
        label: "หมายเลข Ticket ลูกค้า",
        size: 3,
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatDate(row)
      },
    ],
    Other: [
      { name: "Technician", label: "ช่างผู้ปฏิบัติงาน" },
      { name: "Date", label: "วันปฏิบัติงาน" },
      {
        name: "Customer_Sign", label: "ลายเซ็นลูกค้า",
        type: "image"
      }
    ]
  };

  const showData = (field) => {
    return field.map(
      (
        { name, label, size, classNames, style, findValue },
        idx
      ) => {

        var parts = name.split(".");
        const result = currentData ? (parts.length == 1 ? currentData[name]
          : currentData[parts[0]][parts[1]]) : ""
        return (
          <Col
            key={idx}
            sm={size ? size : size === null ? null : 3}
            className={classNames?.col}
          >
            {name && (
              <FloatingControlComponent
                readOnly
                type="text"
                name={name}
                label={label}
                className={classNames}
                style={style}
                value={result}
              />
            )}
          </Col>
        );
      }
    );
  };

  const columns = {
    Standard: [
      {
        name: "ลำดับ",
        selector: (row) => row?.rowIndex, width: "82px"
      },
      {
        name: "ขั้นตอนการปฏิบัติงาน",
        selector: (row) => row?.detail,
        grow: 3
      },
      {
        name: "Priority",
        selector: (row) => row?.priority,
        // defaultData?.tableStandard?.find(el =>  el?.item_step_id == row?.item_step_id)?.priority,
        minWidth: "130px"
      },
      {
        name: "เหตุผลที่ข้ามขั้นตอน",
        selector: (row) => optionReason.find(ele => ele.Id == row?.reason)?.Reason_Desc,
        minWidth: "220px",
        grow: 2
      },
      {
        name: "วันที่ (Current)",
        selector: (row) => formatDate(row?.last_update_date),
        width: "180px"
      },
      {
        name: "หมายเหตุ",
        selector: (row) => row?.remark,
        minWidth: "140px"
      }
    ],
    Check: [
      {
        name: "ลำดับ",
        selector: (row) => row?.rowIndex, width: "82px"
      },
      {
        name: "รหัสอุปกรณ์/อะไหล่",
        selector: (row) => row?.equip_no,
        grow: 3
      },
      {
        name: "Model Number",
        selector: (row) => row?.model_number,
        grow: 3
      },
      {
        name: "อะไหล่ในสัญญา Lumsum",
        selector: (row) => row?.lumsum,
        grow: 3
      },
      {
        name: "วันหมดอายุ",
        selector: (row) => row?.expire,
      minWidth: "150px"
      },
      {
        name: "วันทำงานล่าสุด",
        selector: (row) => row?.lastDate,
        minWidth: "160px"
      },
      {
        name: "สถานะล่าสุด",
        selector: (row) => row?.status,
        minWidth: "150px"
      },
      {
        name: "ถึงวัน",
        selector: (row) => row?.date,
        minWidth: "150px"
      },
      {
        name: "Priority",
        selector: (row) => row?.priority,
        minWidth: "130px"
      },
      {
        name: "Plan Status",
        selector: (row) => row?.plan_status,
        minWidth: "150px"
      },
      {
        name: "Actual Status",
        selector: (row) => row?.actual_status,
        minWidth: "160px"
      },
      {
        name: "เหตุผล",
        selector: (row) => optionReason.find(ele => ele.Id == row?.reason_id)?.Reason_Desc,
        minWidth: "150px"
      },
      {
        name: "จำนวนที่ใช้",
        selector: (row) => row?.use_num,
        minWidth: "150px"
      },
      {
        name: "Use Flag",
        selector: (row) => row?.use_status,
        minWidth: "150px"
      },
    ],
    Record: [
      {
        name: "ลำดับ",
        selector: (row) => row?.rowIndex, width: "82px"
      },
      {
        name: "ขั้นตอนการปฏิบัติงาน",
        selector: (row) => row?.detail,
        grow: 3
      },
      {
        name: "ค่ามาตรฐาน",
        selector: (row) => row?.standard_value,
        width: "150px"
      },
      {
        name: "ค่าจริง",
        selector: (row) => row?.actual_value,
        width: "150px"
      },
      // {
      //   name: "Priority",
      //   selector: (row) => row?.priority
      // },
      {
        name: "วันที่ (Current)",
        selector: (row) => formatDate(row?.last_update_date),
        width: "180px"
      },
      {
        name: "หมายเหตุ",
        selector: (row) => row?.remark
      }
    ],
    Special: [
      {
        name: "ลำดับ",
        selector: (row) => row?.rowIndex, width: "82px"
      },
      {
        name: "รายละเอียดข้อกำหนด",
        selector: (row) => row?.detail
      },
      {
        name: "PM/Round",
        selector: (row) => row?.pm_no
      },
      {
        name: "หมายเหตุ",
        selector: (row) => row?.remark
      }
    ],
  };

  useEffect(() => {

    const q = getQueryString({
      seq_no: state?.Seq_No,
      page: 1,
      limit: 100
    })
    let defaultData = {}
    const d = (state.TechnicianPlan.TechWorkJobs[0])

    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: ServiceRequestService.getItemStepDes(q),
      callback: (res) => {
        const arrayStep = res.map(el => ({
          item_step_id: el.Item_Step_Id,
          item_step_des_id: el.Id, //el.Item_Step_Id,
          detail: el.Item_Step_Des,
          priority: el.Item_Step_Priority,
          reason: el.Item_Step_Reason,
          remark: "",
          file: []
        }))
        defaultData = { ...defaultData, tableStandard: arrayStep }
        const check = state.TechnicianPlan?.TechWorkJobs[0]?.TechWorkChecks[0]
        setCurrentData(prev => ({
          ...prev,
          tableStandard: d?.TechWorkSteps.map(el => ({
            ...el,
            detail: arrayStep?.find(st => st.item_step_id == el.item_step_id)?.detail,
            priority: arrayStep?.find(st => st.item_step_id == el.item_step_id)?.priority,
            reason: arrayStep?.find(st => st.item_step_id == el.item_step_id)?.priority
          })),
          tableCheck: state?.ServiceRequestDt.map(ele => ({
            ...ele,
            equip_no: ele.BillOfReqDt?.Item.Item_Code,
            equip_detail: ele.BillOfReqDt?.Item.Item_Name_TH || ele.BillOfReqDt?.Item.Item_Name_EN,
            model_number: ele.BillOfReqDt?.Item.Item_Model,
            lumsum: ele?.Foc?.FOC_ReasonName,
            expire_date: "",
            check_date: "",
            next_start: "",
            end_start: "",
            plan_status: check?.plan_status,
            actual_status: ele?.actual_status == "change" ? "เปลี่ยน" : "เช็ค",
            reason_id: check?.reason_id,
            use_num: check?.item_use_qty,
            use_status: ele.BillOfReqDt?.Use_Status,
          }))
        }))
      }
    });
    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: ServiceRequestService.getContractSpec(q),
      callback: (res) => {
        const arraySp = res.map(el => ({
          detail: el.Con_Spec_Des,
          other: el.remark,
          pm_no: el.PM_Of_Work,
          id: el.Id,
        }))
        defaultData = { ...defaultData, tableSpecial: arraySp }
        setCurrentData(prev => ({
          ...prev,
          tableSpecial: arraySp
        }))
      }
    });
    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: ServiceRequestService.getStandardRec(q),
      callback: (res) => {
        const array = res.map(item => ({
          detail: item.Item_Record_Des,
          standard_value: item.Record_Value,
          record_value: item.Actual_Value,
          unit: item.Record_UOM,
          remark: item.Remark,
          id: item.Id,
          file: []
        }))
        defaultData = { ...defaultData, tableRecord: array }
      
        setCurrentData(prev => ({
          ...prev,
          tableRecord: d?.TechWorkRecords.map(el => ({
            ...el,
            standard_value: array?.find(st => st.id == el.item_step_id)?.standard_value,
            // priority: defaultData?.tableRecord?.find(st => st.id == el.item_step_id)?.priority,
            detail: array?.find(st => st.id == el.item_step_id)?.detail
          }))
        }))
      }
    });

    let blob
    const filePath = (state.TechnicianPlan.TechWorkClosed.TechWorkClosedFile.file_path)

    getServiceRequest({
      showAlert: () => {},
      setLoading,
      serviceRequest: FileUploadsService.getFileUploads("signature", filePath || ""),
      callback: (res) => {
        blob = URL.createObjectURL(res)

        setCurrentData({
          ...state,
          Customer_Sign: blob,
          Printed_By: user?.username,
          Printed_Date_Time: currentDate
        })

        // setDefaultData(defaultData)
      }
    })

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ServiceRequestService.getReason(q),
      callback: (res) => { setOptionReason(res) }
    });
  }, []);

  const currentDate = formatDateTime(new Date().toISOString());
  const [currentData, setCurrentData] = useState({})
  const [optionReason, setOptionReason] = useState([])

  return (
    <>
      <Helmet>
        <title>ใบรายงานบริการ</title>
        <meta name="description" content="" />
      </Helmet>

      <Container fluid className="p-3">
        <div className="position-relative">
          <PrintButton
            componentRef={canvasRef}
            button={{ style: { zIndex: 10, top: "25px", right: "25px" } }}
          />

          <Card.Body ref={canvasRef} className="mt-1">
            <CardDisplayComponent
              header={{
                title: {
                  className: "mb-0 fs-2 text-center",
                  text: `รายละเอียดการทำงาน`
                }
              }}
              body={{
                as: Row,
                className: "mx-5",
                element: (
                  <>
                    <Col
                      sm={9}
                      className="ReportHead mb-3 d-flex align-items-center"
                    >
                      <ReportHeadComponent formName="SERVICE REQUEST FORM" />
                    </Col>

                    <Col as={Row} className="mb-3">
                      {showData(inputField.headerReport)}
                    </Col>

                    {showData(inputField.Inform)}
                  </>
                )
              }}
            />

            <CardDisplayComponent
              header={{
                className: "mx-5",
                title: { text: "ขั้นตอนการทำงานมาตรฐาน" }
              }}
              body={{
                as: Row,
                className: "mx-5",
                // element: <Table data={currentData.TechnicianPlan?.TechWorkJobs[0]?.TechWorkSteps || []} column={columns.Standard} />
                element: <Table data={currentData.tableStandard || []} column={columns.Standard} />
              }}
            />

            <CardDisplayComponent
              header={{
                className: "mx-5",
                title: { text: "คำสั่ง ตรวจสอบ / เปลี่ยน sparepart" }
              }}
              body={{
                as: Row,
                className: "mx-5",
                element: <Table data={currentData.tableCheck || []} column={columns.Check} />
              }}
            />
            <CardDisplayComponent
              header={{
                className: "mx-5",
                title: { text: "คำสั่งการบันทึกข้อมูล" }
              }}
              body={{
                as: Row,
                className: "mx-5",
                element: <Table data={currentData.tableRecord || []} column={columns.Record} />
              }}
            />
            <CardDisplayComponent
              header={{
                className: "mx-5",
                title: { text: "คำสั่งพิเศษ" }
              }}
              body={{
                as: Row,
                className: "mx-5",
                element: <Table data={currentData.tableSpecial || []} column={columns.Special} />
              }}
            />

            <CardDisplayComponent
              body={{
                as: Row,
                className: "justify-content-around ",
                element: inputField.Other.map(({ name, label, type }) => {
                  if (type == "image") {
                    return (
                      <Col key={name} sm={3} >
                        <div className="relative">
                          <FloatingControlComponent
                            readOnly
                            type="text"
                            name={name}
                            label={label}
                          />
                          <div className="position-absolute top-0 bg-light mt-6 ms-3 ">
                            <img src={currentData[name]} height={"35px"} className="" />
                          </div>
                        </div>
                      </Col>
                    )
                  }
                  return (
                    <Col key={name} sm={3} >
                      <FloatingControlComponent
                        readOnly
                        type="text"
                        name={name}
                        label={label}
                        value={formatSplitKey(name, ".", currentData)}
                      />
                    </Col>
                  )
                })
              }}
            />
          </Card.Body>
        </div>

        {/* <Card className="m-1 mb-4  border-0">
          <CardDisplayComponent
            body={{
              element: (
                <PaginationComponent
                  data={state?.Work || []}
                  currentPage={currentPage}
                  itemsPerPage={1}
                  onPageChange={(newPage) => setCurrentPage(newPage)}
                />
              )
            }}
          />
        </Card> */}

        <Card className="m-1 mb-4  border-0">
          <CardDisplayComponent
            footer={{
              className: "text-center",
              element: (
                <Button
                  variant="outline-secondary"
                  className="px-4 py-2 text-dark rounded-pill"
                  onClick={() =>
                    navigate("/service_work/perform/report")
                  }
                >
                  ย้อนกลับ
                </Button>
              )
            }}
          />
        </Card>
      </Container >
    </>
  );
};

export default PreviewReportPage;
